module.exports = __webpack_public_path__ + "img/backup.863697d3.jpg";